/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, HostListener, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GlobalAlertServiceService } from './projectservice/globalAlert.service';
import { Router } from '@angular/router';
import { LoginService } from './projectservice/login.service';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('popupSuccessModel', { static: false }) popupSuccessModel: ModalDirective;
  @ViewChild('confirmBox', { static: false }) confirmBox: ModalDirective;
  title = '';
  show: boolean = false;
  alert = {
    type: '',
    message: ''
  }
  confirmMsg = { message: '', s: () => { }, f: () => { } };
  confirmBoxRes: any;
  alertbox: any;

  idleTimer: any;
  idleTimeout = 20 * 60 * 1000;
  lastActivity: number = Date.now();

  constructor(private _global: GlobalAlertServiceService, private _router: Router, private _login: LoginService) { }

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.alertbox = this._global.onMessage().subscribe(data => {
      this.alert.type = data.type == 'alert' ? 'alert alert-danger' : 'alert-success',
        this.alert.message = data.message;
      if (this.alert.message) {
        this.popupSuccessModel.show();
        setTimeout(() => {
          this.popupSuccessModel.hide();
        }, 4000
        );
      }
    })
    this.confirmBoxRes = this._global.onConfirmMsg().subscribe(data => {
      this.confirmMsg = data;
      this.confirmBox.show();
    })
    this.startIdleTimer();
  }

  ngOnDestroy(): void {
    this.alertbox.unsubscribe();
    if (this.idleTimer) {
      clearInterval(this.idleTimer);
    }
  }

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:click')
  @HostListener('document:scroll')
  updateLastActivity() {
    this.lastActivity = Date.now();
  }

  startIdleTimer() {
    this.idleTimer = setInterval(() => {
      if (this._login.getLoggedInUser()) {
        const timeSinceLastActivity = Date.now() - this.lastActivity;
        if (timeSinceLastActivity >= this.idleTimeout) {
          this.logoutDueToInactivity();
        }
      }
    }, 10000);
  }

  logoutDueToInactivity() {
    this._global.alert({ type: 'alert', message: 'Session expired due to inactivity. Please login again.' });
    this._router.navigate(['/logout']);
  }

  confirmMessageYesClick() {
    this.confirmBox.hide();
    this.confirmMsg.s();
  }
  cancleEvent() {
    this.confirmBox.hide();
    this.confirmMsg.f();
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

}